import React from "react";

import DataTable from "@components/DataTableV2/DataTable";
import ProgressSpinner from "@components/ProgressSpinner";

import { useSubscriptionAccountsTab } from "./SubscriptionAccountsTab.hooks";

import { ConfirmInvoiceModal } from "../../../components";

const SubscriptionAccountsTab = () => {
  const {
    loading,
    dataTableConfig,
    handleCloseConfirmDialog,
    handleConfirmInvoice,
    invoiceDialogType,
    shouldShowConfirmDialog,
    tentativeDetails,
  } = useSubscriptionAccountsTab();

  return (
    <>
      {loading && <ProgressSpinner />}
      {shouldShowConfirmDialog && (
        <ConfirmInvoiceModal
          type={invoiceDialogType}
          data={tentativeDetails}
          onCancel={handleCloseConfirmDialog}
          onSubmit={handleConfirmInvoice}
        />
      )}
      <DataTable config={dataTableConfig} resetData={!loading} />;
    </>
  );
};

export default SubscriptionAccountsTab;
